module.exports = __webpack_public_path__ + "static/img/moren.09dd6b70.png";